module.exports = require("./../../_gen/starling/textures/SubTexture");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/textures/SubTexture.js
// module id = 236
// module chunks = 0